import { useState } from 'react';
import type { Faction } from '@tb/shared';

// ---------------------------------------------------------------------------
// The side this device fights for (docs/SPRINT.md item 4): chosen on the
// lobby's side cards and remembered like the commander's name, for the war,
// both battles and training alike. None means either side: the server puts the
// commander where there are fewer humans.
// ---------------------------------------------------------------------------

const SIDE_KEY = 'tb.side';

/** The side chosen on this device, or null for either. */
export function chosenSide(): Faction | null {
  try {
    const v = localStorage.getItem(SIDE_KEY);
    return v === 'WEST' || v === 'EAST' ? v : null;
  } catch {
    return null;
  }
}

/** Remember a side, or forget it for either. */
export function chooseSide(side: Faction | null): void {
  try {
    if (side) localStorage.setItem(SIDE_KEY, side);
    else localStorage.removeItem(SIDE_KEY);
  } catch { /* this visit only */ }
}

/** The chosen side as lobby state, kept on the device as it changes. */
export function useChosenSide(): [Faction | null, (side: Faction | null) => void] {
  const [side, setSide] = useState(chosenSide);
  return [side, (next) => { chooseSide(next); setSide(next); }];
}
